import React from "react";
import {NumberInput, Text} from "@mantine/core";
import {IMeasureHeartRateStep} from "../../../types/protocol";
import {IMeasureHeartRateStepDefinition} from "../../../types/protocolDefinitions";
import classes from "../StepView.module.css";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {TWorkflow} from "../StepView";

/** Union type for HR measurement steps (both execution and planning modes) */
type HrStep = IMeasureHeartRateStep | IMeasureHeartRateStepDefinition;

export interface MeasureHrStepViewProps {
    step: HrStep;
    onChange: (updates: DeepPartial<HrStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for heart rate measurement steps.
 * This is the primary rendering for HR measurement steps in all contexts.
 * Used in both protocol execution and planning modes.
 */
export const MeasureHrStepView: React.FC<MeasureHrStepViewProps> = ({
    step,
    onChange,
    workflow = "session",
}) => {
    const isReadOnly = workflow === "review";

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
            <div className={classes.stepViewRow}>
                <div className={classes.stepViewField}>
                    <NumberInput
                        label={"Heart Rate"}
                        miw={"6em"}
                        className={classes.stepViewInputNarrow}
                        data-testid="input-bpm"
                        size="xs"
                        placeholder="BPM"
                        defaultValue={step.bpm}
                        min={1}
                        allowNegative={false}
                        hideControls
                        disabled={isReadOnly}
                        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                            const numValue = parseInt(e.currentTarget.value, 10);
                            const safeValue = isNaN(numValue) ? undefined : numValue;
                            onChange({
                                bpm: safeValue && safeValue >= 0 ? safeValue : undefined,
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};